module.exports = __webpack_public_path__ + "e6c8f834e2f923b5ad0bbb571f78472a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/category_icons/ic_internationaltopup.png
// module id = 950
// module chunks = 0